<template>
  <div class="coupon-list">
    <div v-if="!couponList.length" class="no-data">
      {{ $t('noData') }}
    </div>
    <div v-for="(item,index) in couponList" :key="index" class="coupon-item"
         :class="{'available': status ==='available','used':status === 'used','expired': status === 'expired'}">
      <div class="coupon-value">
        <div v-if="item.percentage" class="rate">{{ item.percentage }}%</div>
        <div v-else class="amount">
          <span class="unit">Rp</span>
          <span class="number">{{ item.rebate | formatMoney(true, true)}}</span>
        </div>
      </div>
      <div class="coupon-detail">
        <div class="name">{{ item.displayName[locale] }}</div>
        <div class="desc" v-if="item.limitInvestMinAmount">
          {{ $t('investLimit') }} {{ item.limitInvestMinAmount | formatMoney }}
        </div>
        <div v-else class="desc">
          {{ $t('noLimit') }}
        </div>
        <div class="operation">
          <div class="btn-use">
            <md-button
              type="primary"
              round
              plain
              size="small"
              :inactive="status!=='available'"
              @click="useCashCoupon(item)"
            >
              {{ $t('use') }}
            </md-button>
          </div>
          <div class="expired-time">{{ $t('expireDate') }} {{ item.expirationTimestamp | formatDate('.') }}</div>
        </div>
      </div>
    </div>
    <cash-coupon-popup
      :visible="cashCouponPopupVisible"
      :couponInfo="currentCashCoupon"
      @hideDialog="cashCouponPopupVisible = false"
    ></cash-coupon-popup>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'
import CashCouponPopup from '@/components/user/ticket/CashCouponPopup'

export default {
  i18n: {
    messages: {
      en: {
        use: 'USE',
        expireDate: 'Expire Date',
        noData: 'No Data',
        investLimit: 'Invest at least ',
        noLimit: 'No minimum investment amount',
        kycTip: 'To use coupon you have to complete onboarding process',
      },
      id: {
        use: 'Gunakan',
        expireDate: 'Tanggal berakhir',
        noData: 'No Data',
        investLimit: 'Minimum pendanaan ',
        noLimit: 'Tidak ada batas minimum pendanaan',
        kycTip: 'Untuk menggunakan kupon Anda harus verifikasi data pribadi dahulu"',
      },
    },
  },
  components: {
    [Button.name]: Button,
    CashCouponPopup,
  },
  props: {
    status: {
      type: String,
      default: 'available',
    },
    couponList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      cashCouponPopupVisible: false,
      currentCashCoupon: null,
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  methods: {
    useCashCoupon(info) {
      // 如果是现金券，可点击使用; 加息券或满加券，跳转到产品购买页;
      if (info.type === 'CASH_COUPON') {
        if (this.userInfo.status !== 'ENABLED') {
          this.$toast.info(this.$t('kycTip'))
          return
        }
        this.cashCouponPopupVisible = true
        this.currentCashCoupon = info
      } else {
        if (window.bridge && window.bridge.changeMainTab) {
          window.bridge.changeMainTab(1)
          return
        }
        this.$router.push({ name: 'Product' })
      }
    },
  },
  watch: {
    status: function(newVal, oldVal) {
      console.log(newVal)
    },
  },

}
</script>

<style scoped lang="stylus">
.coupon-list {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.coupon-item {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 16px 16px 16px 0;
  width: 100%;
  max-width: 320px;
  height: 104px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .coupon-value {
    width: 36%;
    text-align: center;
    .rate {
      font-family: 'Reducto';
      font-size: 36px;
      line-height: 40px;
    }
    .amount {
      .unit {
        font-family: 'Reducto';
        font-size: 14px;
        margin-right: 2px;
      }
      .number {
        font-family: 'Reducto';
        font-size: 24px;
      }
    }
  }
  .coupon-detail {
    width: 58%;
    height: 100%;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .name {
      font-size: 14px;
    }
    .desc {
      font-size: 10px;
    }
    .operation {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
    .btn-use {
      .md-button.primary {
        font-size: 9px;
        line-height: 12px;
        width: auto;
      }
    }
    .expired-time {
      color: #c0c0c0;
      font-size: 9px;
    }
  }
  &.available {
    background-image: url('../../../assets/image/user/ticket/bg-coupon-available.png');
    .coupon-value {
      color: color-primary;
    }
    .name {
      color: #3F424E;
    }
    .desc {
      color: #888;
    }
  }
  &.used {
    background-image: url('../../../assets/image/user/ticket/bg-coupon-used.png');
  }
  &.expired {
    background-image: url('../../../assets/image/user/ticket/bg-coupon-expired.png');
  }
  &.used, &.expired {
    .coupon-value {
      color: #b5b5b5;
    }
    .name {
      color: #b5b5b5;
    }
    .desc {
      color: #b5b5b5;
    }
  }
}
</style>
